import React from 'react';

const Modal = ({
    isOpen,
    onClose,
    title,
    children,
    footer,
    style = {},
    maxWidth = '800px',
    maxHeight = '90vh',
    zIndex = 1100
}) => {
    if (!isOpen) return null;

    const styles = {
        modalOverlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: zIndex,
            padding: '20px'
        },
        modalContent: {
            backgroundColor: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            ...style
        },
        modalHeader: {
            padding: 'clamp(12px, 2vw, 16px) clamp(16px, 3vw, 24px)',
            borderBottom: '1px solid var(--border)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: 'var(--surface)',
        },
        modalHeaderTitle: {
            margin: 0,
            fontSize: '1.1rem',
            color: 'var(--fg-primary)',
            fontWeight: '700'
        },
        modalClose: {
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: 'var(--fg-secondary)',
            lineHeight: 1,
            padding: '0',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            transition: 'background 0.15s'
        },
        modalBody: {
            padding: 'clamp(16px, 3vw, 24px)',
            overflowY: 'auto',
            flex: 1,
            color: 'var(--fg-primary)'
        },
        modalFooter: {
            padding: 'clamp(10px, 2vw, 14px) clamp(16px, 3vw, 24px)',
            borderTop: '1px solid var(--border)',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.75rem',
            backgroundColor: 'var(--surface)'
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div style={styles.modalOverlay} onClick={handleOverlayClick}>
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <h2 style={styles.modalHeaderTitle}>{title}</h2>
                    <button
                        style={styles.modalClose}
                        onClick={onClose}
                        onMouseEnter={(e) => e.currentTarget.style.background = 'var(--border)'}
                        onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
                        aria-label="Close modal"
                    >
                        ×
                    </button>
                </div>

                <div style={styles.modalBody}>
                    {children}
                </div>

                {footer && (
                    <div style={styles.modalFooter}>
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;

